
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.79 4.28c0 1.71-1.39 3.1-3.1 3.1-1.71 0-3.1-1.39-3.1-3.1 0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1zM7.4 11.498c0 1.71-1.39 3.1-3.1 3.1-1.71 0-3.1-1.39-3.1-3.1 0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1zM19.79 18.733c0 1.71-1.39 3.1-3.1 3.1-1.71 0-3.1-1.39-3.1-3.1a3.094 3.094 0 116.19 0h.01zM6.979 13.056l7.05 4.11m-.01-11.33l-7.04 4.11","stroke":"#1F4053","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    